// How many featured artworks the homepage shows (the first N of the featured list, in the admin's order).
export const HOME_FEATURED_COUNT = 4;

/**
 * Featured artworks in display order: the order set in Admin > Featured Order (featured_order),
 * and any featured artwork without a position (newly featured) after them, in the API's order (newest first).
 */
export function sortFeatured(artworks) {
  const featured = (artworks || []).filter((a) => a.featured);
  const pos = (a) => (typeof a.featured_order === 'number' ? a.featured_order : Number.MAX_SAFE_INTEGER);
  // Array.prototype.sort is stable, so artworks without a position keep their newest-first order
  return featured.slice().sort((a, b) => pos(a) - pos(b));
}
